const INITIAL_STATE = {
	aguardando: false,
	listaAgrupadoPorSituacao: [],
	listaAgrupadoPorStatus: [],
	listaPorVencimento: []
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {

		case 'DASHBOARD_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

		case 'DASHBOARD_POR_SITUACAO_LISTADO':
            return {
				...state,
				listaAgrupadoPorSituacao: action.payload.data
			};

		case 'DASHBOARD_POR_STATUS_LISTADO':
            return {
				...state,
				listaAgrupadoPorStatus: action.payload.data
			};

		case 'DASHBOARD_POR_VENCIMENTO_LISTADO':
            return {
				...state,
				listaPorVencimento: action.payload.data
			};
			
        default:
            return state;
    }
}
